import React from 'react';
import FancyButton from '../components/FancyButton';

const locations = [
  {
    name: 'Studio Fernandes — Bhayandar East',
    address: 'Shop No 20 & 21, Sarvodaya Complex, Golden Nest Circle, Bhayandar East, Thane 401105',
    landmark: 'Next to Airtel Gallery and opposite Balaji Hospital',
    phone: '8850556692',
    img: '/images/storee.webp',
    mapsLink: 'https://maps.google.com/?q=Sarvodaya+Complex+Golden+Nest+Circle+Bhayandar+East+Thane',
  },
  {
    name: 'Studio Fernandes — Borivali West',
    address: 'Shop No. 1, Harmony Society Ltd, Holy Cross Rd, D-Wing, IC Colony Ext, I C Colony, Borivali West, Mumbai 400103',
    landmark: '',
    phone: '09664304393',
    img: '/images/store2.webp',
    mapsLink: 'https://maps.google.com/?q=Harmony+Society+Holy+Cross+Road+IC+Colony+Borivali+West+Mumbai',
  },
  {
    name: 'I.M. Fernandes & Sons — Charni Road',
    address: 'Shop No. Hirabaug, C.P. 2, Cawasji Patel Tank Rd, Charni Road East, Gulal Wadi, Charni Road, Mumbai 400004',
    landmark: '',
    phone: '8850556692',
    img: '/images/store3.webp',
    mapsLink: 'https://maps.google.com/?q=Hirabaug+Cawasji+Patel+Tank+Road+Charni+Road+Mumbai',
  },
];

const VisitStore = () => {
  return (
    <>
      {/* Locations Section */}
      <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-widest text-primary mb-4">Visit Us</p>
          <h2 className="font-display text-3xl md:text-4xl mb-6">Our Locations</h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
            Three ateliers. One legacy. Visit us in person to begin your bespoke journey.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-20">
          {locations.map((loc) => (
            <div key={loc.name}>
              <div className="w-full mb-6 overflow-hidden">
                <img src={loc.img} alt={loc.name} className="w-full h-64 object-cover" />
              </div>
              <h3 className="font-display text-xl mb-2 dark:text-white">{loc.name}</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm mb-1">{loc.address}</p>
              {loc.landmark && (
                <p className="text-gray-500 dark:text-gray-500 text-xs italic mb-1">{loc.landmark}</p>
              )}
              <a href={`tel:+91${loc.phone}`} className="text-gray-600 dark:text-gray-400 text-sm mb-4 block hover:text-primary transition-colors">
                {loc.phone}
              </a>
              <a
                href={loc.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-sm hover:underline uppercase tracking-wider"
              >
                Get Directions
              </a>
            </div>
          ))}
        </div>

        {/* Bulk Orders CTA */}
        <div className="bg-surface-dark text-white p-8 md:p-12 text-center">
          <h3 className="font-display text-2xl md:text-3xl mb-8">For Bulk Orders</h3>
          <FancyButton label="Call Us" href="tel:+918850556692" />
        </div>
      </section>
    </>
  );
};

export default VisitStore;
